export default "__VITE_ASSET__BzJWw4jk__"